import { useContext, useEffect, useState } from 'react';

import { useForm } from "react-hook-form";
import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import { Box, Typography, Button } from '@mui/material';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import { LoadingButton } from 'components/views/form/Button/styles';
import { ReactComponent as IcDonwloadBtn } from 'assets/icons/ic-donwload-btn.svg';
import { ReactComponent as IcIturinOk } from 'assets/icons/ic-iturin-ok.svg';

type ParamsModals = {
    openModal: boolean;
    handleClickClosed: () => void;
    linkInsure?: string;
}

export const ModalSendEmail = ({ openModal, handleClickClosed }: ParamsModals) => {
    const [loadingDonwload, setLoadingDonwload] = useState(false);
    const [loadingSendEmail, setLoadingSendEmail] = useState(false);

    const { register, watch, setValue } = useForm<{ email: string }>();
    const { selectedCar, handlePostPolicyPdfRequest } = useContext(DataContext);

    const email = watch('email');

    const handleSendPdf = (FlSendEmail: boolean) => {
        if (selectedCar) {
            FlSendEmail ? setLoadingSendEmail(true) : setLoadingDonwload(true);

            handlePostPolicyPdfRequest({
                token: localStorage.getItem('token')!,
                body: {
                    CdPerson: selectedCar.CD_PESSOA,
                    Email: email,
                    FlSendEmail,
                    OrderId: selectedCar.CD_PEDIDO
                }
            });
        }
    }

    useEffect(() => {
        setValue('email', '');
        setLoadingDonwload(false);
        setLoadingSendEmail(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal]);

    return (
        <Modals open={openModal}>
            <Box sx={{ textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '23.375rem' } }}>
                <Box sx={{
                    borderRadius: '8px 8px 0 0',
                    padding: { xs: '1.8rem 1rem', md: '1.8rem 1.31rem' }
                }} >
                    <Typography fontSize='1.5625rem' fontWeight={700} textTransform='uppercase'>
                        2ª via apólice
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='21px' paddingTop='.625rem'>
                        <b>Insira</b> o e-mail para envio ou <b>baixe</b> <br />
                        a sua apólice:
                    </Typography>

                    <Box display='grid' sx={{
                        margin: '1rem 0 1.25rem',
                        'button': {
                            color: '#FFF',
                            marginTop: '-1.4rem'
                        }
                    }}>
                        <Input
                            name='email'
                            placeholder='Digite seu e-mail'
                            type='text'
                            label=''
                            register={{ ...register("email", { pattern: Regex.email }) }}
                        />

                        <ButtonRectangle
                            name='ENVIAR E-MAIL'
                            loadingBtn={loadingSendEmail}
                            disabled={!Regex.email.test(email) || loadingDonwload}
                            onClick={() => handleSendPdf(true)}
                        />
                    </Box>

                    {loadingDonwload ?
                        <LoadingButton loading variant="outlined" fullWidth />
                        :
                        <Button variant='outlined' disabled={loadingSendEmail} sx={{
                            width: '100%',
                            height: {
                                xs: '2.5rem',
                                md: '2.3rem',
                                lg: '2.5rem'
                            },
                            borderWidth: '2px',
                            borderRadius: '5px',
                            fontWeight: 700,
                            paddingTop: '.5rem',
                            '&:hover': {
                                borderWidth: '2px',
                            },
                            'svg': {
                                margin: '0 .5rem .1rem 0'
                            }
                        }} onClick={() => handleSendPdf(false)}>
                            <IcDonwloadBtn />
                            BAIXAR APÓLICE
                        </Button>
                    }
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    'button': {
                        width: '100%',
                        height: '3.56rem',
                        color: '#F9FCFF',
                        ':hover': {
                            color: '#F9FCFF'
                        }
                    }
                }}>
                    <ButtonOutlined name='FECHAR' onClick={() => handleClickClosed()} />
                </Box>
            </Box>
        </Modals>
    )
}

export const ModalRedirectedSite = ({ openModal, handleClickClosed, linkInsure = '' }: ParamsModals) => {
    return (
        <Modals open={openModal}>
            <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                    <Typography fontSize='1.5625rem' fontWeight={700} textTransform='uppercase'>
                        2ª via apólice
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='21px' paddingTop='.625rem'>
                        Você será <b>redirecionado</b> para o site da <br />
                        sua seguradora!
                    </Typography>
                </Box>
                <Box sx={{
                    display: 'grid',
                    borderRadius: '0 0 8px 8px',
                    padding: '1.875rem 1rem 1.75rem',
                    backgroundColor: 'primary.main',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        margin: '0 auto',
                        maxWidth: '15.7rem',
                    }
                }}>
                    <ButtonRectangle name='CONTINUAR' onClick={() => window.open(linkInsure, '_target')} />
                    <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                        <ButtonOutlined name='CANCELAR' onClick={() => handleClickClosed()} />
                    </Box>
                </Box>
            </Box>
        </Modals>
    )
}

export const ModalSuccess = ({ openModal, handleClickClosed }: ParamsModals) => {
    return (
        <Modals open={openModal}>
            <Box sx={{ textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '23.375rem' } }}>
                <Box position='relative' sx={{
                    borderRadius: '8px 8px 0 0',
                    margin: '1.8rem 0 2.45rem',
                }}>
                    <IcIturinOk />
                    <Box sx={{
                        left: 0,
                        right: 0,
                        zIndex: '1',
                        margin: '0 auto',
                        bottom: '-.75rem',
                        height: '3.125rem',
                        position: 'absolute',
                        padding: '1.1rem 0 0',
                        borderRadius: '.625rem',
                        backgroundColor: 'white',
                        border: '1.5px solid rgba(151, 201, 61, 0.45)',
                        width: { xs: 'calc(100% - 2rem)', md: '20.7rem' },
                    }}>
                        <Typography fontSize='1.125rem' fontWeight={700} textTransform='uppercase'>
                            2ª Via da Apólice enviada!
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: 'grid',
                    borderRadius: '0 0 8px 8px',
                    padding: '1.25rem 1rem 1.5rem',
                    backgroundColor: 'primary.main',
                    'button': {
                        width: '100%',
                        margin: '0 auto',
                        maxWidth: '15.7rem',
                    }
                }}>
                    <ButtonRectangle name='FECHAR' onClick={() => handleClickClosed()} />
                </Box>
            </Box>
        </Modals>
    )
}

export const ModalError = ({ openModal, handleClickClosed }: ParamsModals) => {
    return (
        <Modals open={openModal}>
            <Box sx={{ textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '23.375rem' } }}>
                <Box sx={{
                    borderRadius: '8px 8px 0 0',
                    padding: '1.9rem 1rem 1.25rem'
                }} >
                    <Typography fontSize='1.5625rem' fontWeight={700} textTransform='uppercase'>
                        Ops! Algo deu errado.
                    </Typography>
                    <Typography fontSize='1rem' paddingTop='.75rem'>
                        Por favor, tente novamente mais tarde!
                    </Typography>
                </Box>
                <Box sx={{
                    display: 'grid',
                    borderRadius: '0 0 8px 8px',
                    padding: '1.37rem 1rem 1.75rem',
                    backgroundColor: 'primary.main',
                    'button': {
                        width: '100%',
                        margin: '0 auto',
                        maxWidth: '15.7rem',
                        borderColor: '#F9FCFF',
                        color: '#F9FCFF',
                        ':hover': {
                            borderColor: '#F9FCFF',
                            color: '#F9FCFF'
                        }
                    }
                }}>
                    <ButtonOutlined name='FECHAR' onClick={() => handleClickClosed()} />
                </Box>
            </Box>
        </Modals>
    )
}
